import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { TurnState } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIHoverActionController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameStateUpdated:
            case UIGameEventEnums.DiceStateUpdated:
            case UIGameEventEnums.FinishedBuildingGame:
            case UIGameEventEnums.PlayerControllerStateUpdated:
                this.updateState();
                break;
            default:
                break;
        }
    }
    getConfirmationParameters(index) {
        return {
            texture: this.getTexture(index),
            canTakeAction: this.canTakeAction,
            action: ()=>{
                this.action(index);
            },
            resourcesToBuild: this.getResourcesToBuild(),
            bankActionAmount: this.getBankActionAmount(index),
            hoverActionController: this
        };
    }
    updateHoverLocations(validLocations, canTakeAction) {
        this.validLocations = validLocations !== null && validLocations !== void 0 ? validLocations : [];
        this._canTakeAction = canTakeAction;
    }
    getResourcesToBuild() {
        return this.resources;
    }
    get canTakeAction() {
        return this._canTakeAction;
    }
    get validLocations() {
        const isCurrentTurnSpecialBuildPhase = this.uiGameManager.gameController.currentState.turnState == TurnState.SpecialBuildPhase;
        if (this.shouldHideOnSpecialBuildPhase && isCurrentTurnSpecialBuildPhase) {
            return [];
        }
        return this._validLocations;
    }
    set validLocations(value) {
        this._validLocations = value;
    }
    constructor(uiGameManager){
        this._validLocations = [];
        this._canTakeAction = false;
        this.resources = [];
        this.shouldHideOnSpecialBuildPhase = false;
        this.useResources = true;
        this.isCornerAction = false;
        this.isShipAction = false;
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
